export default {
  user (state) {
    return state.user
  },
  users (state) {
    return state.users
  },
  list (state) {
    return state.list
  },
  avatar () {
    return '/img/defaultAvatar.png'
  },
  admin (state) {
    return state.user !== null ? state.user.admin : false
  },
  id (state) {
    return state.user !== null ? state.user.id : false
  }
}
